import { settingsGateway } from "@/gateways/settingsGateway";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import type { Settings } from "./types";

export function useGetSettings() {
  const query = useQuery({
    queryKey: ["settings"],
    queryFn: () => settingsGateway.getSettings(),
  });

  return { ...query, getSettingsStatus: query.status, settings: query.data };
}

export function useUpdateSettings() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (settings: Settings) =>
      settingsGateway.updateSettings(settings),
    onSuccess: (settings: Settings) => {
      queryClient.invalidateQueries({ queryKey: ["settings"] });
      queryClient.setQueryData(["settings"], settings);
    },
  });

  return {
    ...mutation,
    updateSettingsStatus: mutation.status,
    updateSettings: mutation.mutate,
  };
}
